module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if(obj && obj.widgetType === 'mosaic_v2'){;
__p += '\n	<li class="photo_block uploader_tile large fade_in" tabindex="0">\n';
} else {;
__p += '\n	<li class="photo_block uploader_tile" tabindex="0">\n';
};
__p += '\n';
 if (hasTOS) { ;
__p += '\n    <button id="end_uploader_tile_inside">' +
__e( I18n.t('widget.upload_now') ) +
'</button>\n';
};
__p += '\n\n</li>\n';

}
return __p
}